import type { StackProps, TypographyProps } from "@mui/material";
import { Stack, Typography } from "@mui/material";
import type { TabularDataCell } from "../../../../../../../../../api/types/svTypes.ts";
import DimensionBooleanValueIcon from "./DimensionBooleanValueIcon.tsx";
import DimensionStartIcon from "../../../common/DimensionStartIcon.tsx";
import { isBoolean } from "../../../../../utilities/isBoolean.ts";
import { DataGridTooltipWrapper } from "../../../../common/DataGridTooltipWrapper.tsx";

interface Props {
  cell: TabularDataCell | undefined;
  formattedValue: string | undefined;
  typographyProps?: TypographyProps;
  containerProps?: StackProps;
}

const DimensionCellDisplayValue = ({ cell, formattedValue, typographyProps, containerProps = {} }: Props) => {
  return (
    <DataGridTooltipWrapper tooltip={cell?.toolTip}>
      <Stack
        direction="row"
        spacing={1}
        {...containerProps}
        sx={[{ alignItems: "center" }, ...(Array.isArray(containerProps.sx) ? containerProps.sx : [containerProps.sx])]}
      >
        {formattedValue && <DimensionStartIcon cell={cell} />}
        {isBoolean(cell?.value) ? (
          <DimensionBooleanValueIcon value={cell?.value} />
        ) : (
          <Typography sx={{ textDecoration: cell?.toolTip ? "underline dotted" : "inherit" }} {...typographyProps}>
            {formattedValue}
          </Typography>
        )}
      </Stack>
    </DataGridTooltipWrapper>
  );
};

export default DimensionCellDisplayValue;
